import { SectionImage } from 'services/api/vehicle-sections/types';
import { useExteriorSectionData } from './useExteriorSection';
import { useGetVehicleId } from 'pages/CreateVehicle/hooks/useGetVehicleId';
import { useGetSectionsQuery } from 'services/api/vehicle-sections';
import { skipToken } from '@reduxjs/toolkit/query';

export const useOBDImages = () => {
  const { images: tiresImages } = useExteriorSectionData('tires');

  const vinPlateImage = tiresImages.find(img => img.type === 'tires.vin_plate');
  const licensePlateImage = tiresImages.find(img => img.type === 'tires.license_plate_registration');

  const vehicleId = useGetVehicleId();
  const { data: sections } = useGetSectionsQuery(vehicleId || skipToken);

  const section = sections?.interior_questions?.subsections?.odb_check_smog_readiness;
  const obdImages = (section?.images || []).filter(img => !!img.url);

  const images = [...obdImages, vinPlateImage, licensePlateImage].filter(Boolean) as SectionImage[];
  return images;
};
